<ng-container>
	<ng-template cdkPortal #shopperNotes="cdkPortal">
		<cdx-modal [center]="true" padding="medium" (closeEmitter)="closeShopperNoteModal()">
			<product-shopper-notes
				[isModal]="true"
				[productName]="product?.name"
				[productImageSrc]="product?.images?.big"
				[sku]="product?.sku"
			>
			</product-shopper-notes>
		</cdx-modal>
	</ng-template>

	<ng-template cdkPortal #removeFromFavourites="cdkPortal">
		<cdx-generic-modal [modalData]="modalDataForRemoveFromList" (modalCTAEmitter)="removeFromList()">
			<p *ngIf="isFromFavouritesList">It will not appear back in My Favourites, even if you purchase it again</p>
		</cdx-generic-modal>
	</ng-template>

	<ng-template #productDes> </ng-template>

	<ng-container *ngIf="visible && product">
		<product-tag
			*ngIf="
				shouldShowIsSampledTag || (product?.productTag && product?.productTag?.tagType !== tagType.IsSampled)
			"
			[tag]="product?.productTag"
			[uniqueId]="uniqueid"
			[price]="product?.price"
			[asStrap]="true"
			[carouselindex]="carouselindex"
		></product-tag>

		<product-fuel-tag *ngIf="product?.productTag" [tag]="product?.productTag"></product-fuel-tag>
		<div class="product-entry product-cup">
			<a
				class="productImage-container"
				routerLink="/shop/productdetails"
				[queryParams]="{ stockcode: product?.sku, name: nameInKebabCase }"
				[class.not-clickable]="isSampledProductInPastOrders"
				[attr.aria-labelledby]="ariaLabelIds"
				#stampLink
				(click)="onClick(position)"
			>
				<figure
					cdxProductImage
					[lazyLoad]="true"
					[images]="product?.images"
					[name]="product?.name"
					labelledBy="product-{{ uniqueid }}-title"
				></figure>
				<div id="product-{{ uniqueid }}-tag">
					<div *ngIf="isBoostOfferActivated; else noBoost" class="boosted" attr.aria-label="Boosted">
						<cdx-svg-icon name="pulse" class="pulse" size="tiny"></cdx-svg-icon>
						Boosted
					</div>
					<ng-template #noBoost>
						<ng-container *ngIf="!!this.productService.adId; else other">
							<div class="promoted" attr.aria-label="Promoted">Promoted</div>
						</ng-container>
						<ng-template #other>
							<div *ngIf="showBoughtBeforeLabel" class="bought-before" attr.aria-label="Bought before">Bought before</div>
						</ng-template>
					</ng-template>
				</div>
			</a>
			<a routerLink="/shop/productdetails" [queryParams]="{ stockcode: product?.sku, name: nameInKebabCase }"
				[class.not-clickable]="isSampledProductInPastOrders" (click)="onClick(position)" tabindex="-1">
				<h3
				i18n="@@product-productTitle"
				id="product-{{ uniqueid }}-title"
				[attr.aria-label]="product?.name + packageType + volumeSize | titlecase | capitalizeSpecificWords | srPunctuation"
				*ngIf="carouselindex === undefined"
				[ngStyle]="{ 'font-weight': isCPUUIAdjustimentOn ? 'bold' : '500' }"
				>
					{{ productTitle | capitalizeSpecificWords }} {{ packageType | capitalizeSpecificWords }}
					<ng-container *ngIf="volumeSize && !isKgItem">{{ volumeSize | capitalizeSpecificWords }}</ng-container>
				</h3>
				<h4
					i18n="@@product-productTitle"
					id="product-{{ uniqueid }}-title"
					[attr.aria-label]="product?.name + packageType + volumeSize | titlecase | capitalizeSpecificWords | srPunctuation"
					*ngIf="carouselindex !== undefined"
					[ngStyle]="{ 'font-weight': isCPUUIAdjustimentOn ? 'bold' : '500' }"
				>
					{{ productTitle | capitalizeSpecificWords }} {{ packageType | capitalizeSpecificWords }}
					<ng-container *ngIf="volumeSize && !isKgItem">{{ volumeSize | capitalizeSpecificWords }}</ng-container>
				</h4>
			</a>
			<div class="product-meta" *ngIf="!isCPUUIAdjustimentOn">
				<product-price-meta
					[uniqueId]="uniqueid"
					[size]="product?.size"
					[cupPrice]="cupPrice"
					[isKgItem]="isKgItem"
					[supportsEachAndKgPricing]="product.supportsBothEachAndKgPricing"
				></product-price-meta>
				<product-price-single-unit-average
					[singleUnitPrice]="product?.price?.averagePricePerSingleUnit"
					[uniqueId]="uniqueid"
					[supportsEachAndKgPricing]="product.supportsBothEachAndKgPricing"
					[departmentName]="productDepartmentName"
					[packageType]="product?.size?.packageType"
				></product-price-single-unit-average>
			</div>
			<div class="product-meta" *ngIf="isCPUUIAdjustimentOn">
				<product-price-meta-v2
					[uniqueId]="uniqueid"
					[size]="product?.size"
					[cupPrice]="cupPrice"
					[shouldShowNoMemberCupPrice]="shouldShowNoMemberCupPrice"
					[noMemberCupPrice]="noMemberCupPrice"
					[multiCupPrice]="multiCupPrice"
					[shouldShowMultiBuyCupPrice]="shouldShowMultiBuyCupPrice"
					[isKgItem]="isKgItem"
					[isKgItem]="isKgItem"
					[supportsEachAndKgPricing]="product.supportsBothEachAndKgPricing"
					[tagLink]="tagLink"
					[isCPUUIAdjustimentOn]="isCPUUIAdjustimentOn"
				></product-price-meta-v2>
				<product-price-single-unit-average
					[singleUnitPrice]="product?.price?.averagePricePerSingleUnit"
					[uniqueId]="uniqueid"
					[supportsEachAndKgPricing]="product.supportsBothEachAndKgPricing"
					[departmentName]="productDepartmentName"
					[packageType]="product?.size?.packageType"
				></product-price-single-unit-average>
			</div>
			<product-price
				ngClass="product-price-cup-adjustment"
				[uniqueId]="uniqueid"
				[price]="product?.price"
				[unit]="product?.unit"
				[isProductTagClubPrice]="isProductTagClubPrice"
				*ngIf="shouldShowPrice"
			>
			</product-price>
		</div>
		<footer>
			<div *ngIf="productIsInStock && supportsBothEachAndKgPricing">
				<product-each-kg-selector
					*ngIf="!isEachKgItemAdded"
					[uniqueId]="uniqueid"
					[purchasingUnit]="product?.selectedPurchasingUnit"
					(unitChangeEmitter)="handlePurchasingUnitChange($event)"
				></product-each-kg-selector>
			</div>

			<cdx-notification
				*ngIf="productIsAvailable"
				#notification
				iconName="tick-sign"
				colour="green"
				[content]="inTrolleyText"
				[canShow]="showNotification"
				[floating]="true"
			>
			</cdx-notification>

			<product-add-to-trolley
				[id]="uniqueid"
				[unit]="pricingUnit"
				[title]="product?.name"
				[shopper]="isShopper"
				[productIsAvailable]="productIsAvailable"
				[productIsInStock]="productIsInStock"
				(addToTrolleyEmitter)="addToTrolleyClick(pageSource, target, sourceCarousel)"
				(updateQuantityEmitter)="updateQuantity($event, pageSource, target, sourceCarousel)"
				(changeEmitter)="addToTrolleyClick(pageSource, target, sourceCarousel)"
			></product-add-to-trolley>
		</footer>

		<div class="product-secondaryActions">
			<button
				cdxButton
				*ngIf="!shouldShowIsSampledTag"
				class="product-notes"
				fillStyle="flat"
				[attr.aria-label]="shopperNoteLabel"
				(click)="shopperNoteClick()"
			>
				<cdx-svg-icon [name]="shopperNotesIcon" fill="green"></cdx-svg-icon>
			</button>

			<button
				cdxButton
				class="product-remove"
				fillStyle="flat"
				[attr.aria-label]="removeFromListLabel"
				(click)="removeFromListClick()"
				*ngIf="canRemoveFromList"
			>
				<cdx-svg-icon [name]="removeIcon" fill="dark"></cdx-svg-icon>
			</button>
		</div>
	</ng-container>
</ng-container>
